
  import { defineComponent, ref } from 'vue';
  import { BackButton } from './BackButton';
  import { Buttons } from './Buttons';
  import { Filters } from './Filters';
  import { TemplateList } from './TemplateList';

  export default defineComponent({
    name: 'OldChecklistChooseTemplatePage',
    components: {
      BackButton,
      Buttons,
      Filters,
      TemplateList,
    },
    setup() {
      const isMakingRequest = ref(true);

      return {
        isMakingRequest,
      };
    },
  });
